export enum Currencies
{
    USD = 'USD'
}
export default Currencies;


// WEBPACK FOOTER //
// ./src/types/enums/Currencies.ts